import { runSagaMiddleware, store } from './src/store/createStore';
import { Provider } from 'react-redux';
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export const wrapWithProvider = ({ element }: { element: any }) => {
  runSagaMiddleware();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>{element}</Provider>
    </QueryClientProvider>
  );
};
